<script setup lang="ts">
import { ref, provide, onMounted, getCurrentInstance, defineExpose } from "vue";

const openedId = ref<string | null>(null);

function requestOpen(id: string) {
  openedId.value = openedId.value === id ? null : id;
}

function registerInitialOpened(id: string) {
  if (openedId.value == null) {
    openedId.value = id;
  }
}

// 子のopenedを検出して初期値にセット
onMounted(() => {
  const slot = (getCurrentInstance()?.slots?.default?.() ?? []);
  for (const vnode of slot) {
    // VNodeのpropsまたはcomponent?.propsを確認
    const props = vnode.props || vnode.component?.props;
    if (props && props.opened) {
      openedId.value = props.id;
      break;
    }
  }
});

function forceOpen(id: string) {
  if (!id) return;
  openedId.value = id;
}

defineExpose({
  forceOpen,
});

provide("accordionGroup", {
  openedId,
  requestOpen,
  registerInitialOpened,
  forceOpen,
});
</script>

<template>
  <div>
    <slot />
  </div>
</template> 